// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c3f6675d","828":"326e4bce"}[chunkId] + ".chunk.js";
};